export const TESTIMONIALS = [
	{
		quote: '',
		name: 'Kanye West',
		img: '/img/kanye-01.png',
		jobTitle: 'Mayor of Kanye City'
	},
	{
		quote: '',
		name: 'Kanye West',
		img: '/img/kanye-02.png',
		jobTitle: 'Mayor of Kanye City'
	},
	{
		quote: '',
		name: 'Kanye West',
		img: '/img/kanye-03.png',
		jobTitle: 'Mayor of Kanye City'
	},
]
